import {
  testDatas
} from "./test-datas"
import {
  testIgnoreUrls
} from "./test-ignore"

export const testResponse = (response) => {
  // if (!testIgnoreUrls.includes(response.config.url)) {
  let isIgnore = false
  testIgnoreUrls.forEach((url) => {
    if (!isIgnore) {
      isIgnore = response.config.url.indexOf(url) > -1
    }
  })
  if (!isIgnore) {
    if (testDatas[response.config.url]) {
      response.data = testDatas[response.config.url]
      console.warn(`[RESPONSE] : TEST DATA "${response.config.url}"`)
    } else {
      console.warn(`[RESPONSE] : `, response)
    }
  }
  return response
}